import React from 'react';
import { Navbar, Nav, NavItem } from 'reactstrap';

const Footer = () => {
  let year = new Date();
  return (
    <Navbar>
      <Nav navbar>
        <NavItem>
          &copy; {year.getUTCFullYear()} - WISOUT
        </NavItem>
      </Nav>
    </Navbar>
  );
};

export default Footer;
